module.exports = __webpack_public_path__ + "img/new-mini-logo.78b379eb.svg";